// extracted by mini-css-extract-plugin
export default {"btn_submit":"FormInput_btn_submit__8ddJI","file-upload":"FormInput_file-upload__d0d2x","upload":"FormInput_upload__PJ+Xp"};